import React from 'react'
import { InputAttrs } from '../../types'
import * as Styled from './Select.styles'

type SelectProps = Omit<InputAttrs<string>, 'onChange'> & {
  placeholder?: string
  isSearchable?: boolean
  isLoading?: boolean
  label?: string
  id?: string
  noOptionsMessage?: () => string
  loadingOptionsMessage?: () => string
  formatOptionLabel?: (option: unknown) => JSX.Element
  onChange: (option: unknown) => void
}

const Select: React.FunctionComponent<SelectProps> = ({
  value,
  onChange,
  options,
  isTouched,
  isValid,
  label,
  isSearchable = false,
  placeholder = 'Selecteer een optie',
  noOptionsMessage = () => 'Geen opties beschikbaar',
  loadingOptionsMessage = () => 'Opties worden geladen',
  disabled,
  id,
  ...props
}) => {
  const optionValue = options.find(option => option.value === value)

  return (
    <Styled.Wrapper>
      {label && <Styled.Label>{label}</Styled.Label>}
      <Styled.Select
        {...props}
        inputId={id}
        isSearchable={isSearchable}
        isDisabled={disabled}
        classNamePrefix="select"
        value={optionValue}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        isValid={!(isTouched && !isValid)}
        noOptionsMessage={noOptionsMessage}
        loadingMessage={loadingOptionsMessage}
        styles={{
          dropdownIndicator: (originalStyles: any, state: any) => ({
            ...originalStyles,
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
          }),
        }}
      />
    </Styled.Wrapper>
  )
}

export default Select
